import { Route, Routes } from 'react-router-dom'
import { PATH } from '~/AppRoutes'
import { useCurrentUser } from '~/common'
import { AddPromotionPage, EditPromotionPage, PromotionDetailsPage, PromotionsPage } from '~/modules/dhl-extra/view'
import { AuthWrapped } from '~/modules/navigation/components'

export const PromotionsRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('MARKETING')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={PromotionsPage} canAccess={canAccess} />} />
      <Route path={PATH.ADD} element={<AuthWrapped component={AddPromotionPage} canAccess={canAccess} />} />
      <Route path={`${PATH.EDIT}/:id`} element={<AuthWrapped component={EditPromotionPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={PromotionDetailsPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const promotionsLinks = {
  showPromotionDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  addPromotionLink: () => `/${PATH.ADD}`,
  editPromotionLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
